// Initialize Yotpo after product recommendations load

function attachYotpoListener() {
  const recommendations = document.querySelectorAll('product-recommendations');

  recommendations.forEach(function (element) {
    element.addEventListener('recommendations:loaded', function () {
      if (typeof yotpoWidgetsContainer !== 'undefined') {
        yotpoWidgetsContainer.initWidgets();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachYotpoListener);
} else {
  attachYotpoListener();
}